export let sessionToken = localStorage.getItem('kochplan-session-token');
if (!sessionToken) {
    gotoLogin();
}

export function forgetSession() {
    localStorage.removeItem('kochplan-session-token');
}

export function gotoLogin() {
    let proto = window.location.protocol;
    let host = window.location.host;
    window.location = `${__OAUTH_BASE_URL__}/authorize?response_type=code&client_id=${__OAUTH_CLIENT_ID__}&scope=openid&redirect_uri=${proto}//${host}/auth-grant.html`;
}
